import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme=>({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden',
    paddingBottom: '40px',
  },
  tableCell: {
    fontSize: '13px',
    border: 'none',
    color: '#000000',
    padding: 0
  },
  table: {
    width: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]:{
      overflowX: 'scroll',
      behavior: 'smooth' ,
      display: 'block',
      width: '100%',
    }
  },
  heading: {
    color: '#071B27',
    fontWeight: 'bold',
    fontSize: '10px',
    fontFamily: 'Fira Sans',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  },
  orderIcon: {
    icon: {
      display: 'none'
    }
  },
  arrowCell: {
    padding: '0',
    width: '10px!important',
    margin: '0'
  },
  nameCell: {
    width: '155px',
    fontWeight: 'bold',
    paddingLeft: 0,
    paddingRight: '20px'
  },
  referenceCell: {
    minWidth: '120px',
    paddingLeft: '20px'
  },
  unitCell: {
    alignItems: 'center',
    width: '248px',
    wordWrap: 'break-word',
    paddingRight: '20px'
  },
  unitIcon: {
    fill: '#0E8BB4',
    verticalAlign: 'bottom',
    marginRight: '10px'
  },
  unitContent: {
    display: 'flex',
    alignItems: 'center'
  },
  guestsContent: {
    display: 'flex',
    alignItems: 'center'
  },
  guestsCell: {
    alignItems: 'center',
    width: '115px',
    paddingRight: '30px'
  },
  cellText: {
    display: 'flex',
    height: '48px',
    alignItems: 'center'
  },
  checkInCell: {
    width: '80px'
  },
  iconButton: {
    padding: '0px 0px 0px 14px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  title: {
    display: 'inline'
  },
  closeIcon: {
    fontSize: '21px'
  },
  checkOutCell: {
    width: '85px',
    paddingLeft: '5px',
    paddingRight: '20px'
  },
  platformCell: {
    width: '96px',
    paddingLeft: '20px'
  },
  addOnsCell: {
    width: '100px',
    paddingLeft: '20px',
    paddingRight: '20px'
  },
  notesCell: {
    width: '200px',
    paddingLeft: '20px',
    paddingRight: '20px'
  },
  addOnTitle: {
    display: 'inline',
    paddingRight: '20px'
  },
  list: {
    padding: '10px',
    margin: '0',
    fontSize: '10px',
    color: '#FFFFFF'
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#E2F5F8'
    }
  },

  disabledArea: {
    position: 'relative',
    '&::after': {
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      background: 'black',
      opacity: 0.2
    }
  }
}));

export default useStyles;
